export default "__VITE_ASSET__fbce188a__"